<template>
  <loader v-bind="{loading}">

    <div v-if="loadFailed" class="notification is-danger is-light">
      This configuration could not be loaded, so it cannot be edited right now. Please reload the page.
    </div>

    <template v-else>

      <div v-if="!editable" class="notification is-warning is-light">
        Only the account's primary user can change this configuration.
      </div>

      <div v-if="hasBespokeLayouts" class="notification is-info is-light">
        Some of your {{ Naming.Jobs.toLowerCase() }} or checklists use a custom-built report layout.
        Those reports are built to order and will not show configured fields.
      </div>

      <report-section
        v-for="key in reportKeys"
        :key="key"
        :report-key="key"
        :title="titleFor(key)"
        v-bind="{catalogue, editable}"
        :unwired="isUnwired(key)"/>

      <div class="columns">
        <div class="column">
          <submit-button
              class="is-success is-rounded"
              left-icon="save"
              :working="saving"
              :disabled="!editable"
              @submit="save">
            Save
          </submit-button>
        </div>
      </div>

    </template>
  </loader>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import ReportSection from './ReportSection'
import reportKeyLabels from './reportKeys'

export default {

  components: {ReportSection},

  data: () => ({
    loading: true,
    saving: false,
  }),

  computed: {
    ...mapGetters('reportFields', [
      'reportKeys',
      'catalogueFailed',
      'configFailed',
      'unwiredReportKeys'
    ]),

    ...mapGetters('reportFields', {
      storeCatalogue: 'catalogue',
      storeEditable: 'editable'
    }),

    catalogue() {
      return this.storeCatalogue || {}
    },

    loadFailed() {
      return this.catalogueFailed || this.configFailed
    },

    editable() {
      return this.storeEditable && !this.loadFailed
    },

    hasBespokeLayouts() {
      return (this.catalogue.bespoke_checklist_count || 0) > 0
        || (this.catalogue.bespoke_job_type_count || 0) > 0
    },
  },

  mounted() {
    Promise.all([
      this.load(),
      this.loadCatalogue(),
    ]).finally(() => {
      this.loading = false
    })
  },

  methods: {
    ...mapActions('reportFields', {
      load: 'load',
      loadCatalogue: 'loadCatalogue',
      saveConfig: 'save'
    }),

    titleFor(key) {
      return reportKeyLabels[key] || key
    },

    isUnwired(key) {
      return this.unwiredReportKeys.includes(key)
    },

    save() {
      this.saving = true

      this.saveConfig().then(() => {
        this.$toast.success('Saved')
        this.saving = false
      }).catch(() => {
        this.$toast.error('Please review your input')
        this.saving = false
      })
    },
  },

}
</script>
